// @flow

import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/form.css'
import { MunicipalitySearch } from 'components/identificator'

export function MunicipalitySelection ({
  match,
  municipalitySelectionHandler
}: {
  match: any,
  municipalitySelectionHandler: number => void
}) {
  return (
    <div className='step municipality-selection'>
      <h2 className='ui header'>
        <div className='sub header'>Schritt 1</div>
        Gemeinde auswählen
      </h2>

      <div className='ui grid'>
        <div className='two column centered stackable row'>
          <div className='column'>
            <div className='ui vertical padded segment'>
              <label htmlFor='search' className='ui sub header'>
                Suchen Sie nach einer Postleitzahl oder dem Gemeindenamen
              </label>
              <MunicipalitySearch
                onSelectionHandler={municipalitySelectionHandler}
              />
              <div className='ui info message'>
                <i className='info circle icon' />
                Zur Zeit stehen nur Gemeinden der Kantone <strong>
                  Bern
                </strong>{' '}
                und <strong>Zürich</strong> zur Verfügung.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/municipalitySelection/index.js